import { render, staticRenderFns } from "./RadioField.vue?vue&type=template&id=2646d925&scoped=true"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"
import style0 from "./RadioField.vue?vue&type=style&index=0&id=2646d925&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2646d925",
  null
  
)

export default component.exports